/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementItemsOptionRequest } from './ShowManagementItemsOptionRequest';

export type ShowManagementCreateShowRequest = {
    type: number;
    count: string;
    count_en?: string;
    count_cn?: string;
    note?: string;
    note_en?: string;
    note_cn?: string;
    post_date?: string;
    open_status: ShowManagementCreateShowRequest.open_status;
    release_setting?: ShowManagementCreateShowRequest.release_setting;
    items?: Array<ShowManagementItemsOptionRequest> | null;
};

export namespace ShowManagementCreateShowRequest {

    export enum open_status {
        EDIT = 'edit',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum release_setting {
        NOW = 'now',
        DATE = 'date',
    }


}

